import { Link } from "react-router-dom";
import { BlockchainContext } from "./context/BlockchainContext";
import { useContext } from "react";

export default function Footer() {
  const { connectWallet, currentAccount } = useContext(BlockchainContext);

  const path = window.location.pathname;
  return (
    <nav className="footer">
      <a className="devButton" href="https://t.me/DegenDapps">
        Dapp Dev
      </a>
    </nav>
  );
}
